import { render } from "./BaseFlashMsg.vue?vue&type=template&id=1a74d21a&scoped=true"
import script from "./BaseFlashMsg.vue?vue&type=script&lang=js"
export * from "./BaseFlashMsg.vue?vue&type=script&lang=js"

import "./BaseFlashMsg.vue?vue&type=style&index=0&id=1a74d21a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a74d21a"]])

export default __exports__